import SiteSchedule from "types/SiteSchedule";
import { streamingApi } from "./base.api";
import { EntityId } from "@reduxjs/toolkit";

const BASE_PATH = "/site-schedules";

export const siteSchedulesApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getSiteScheduleBySiteId: build.query<SiteSchedule, EntityId>({
            query: (siteId) => `${BASE_PATH}/sites/${siteId}/SiteSchedule`,
        }),
    }),
    overrideExisting: true,
});

export const { useGetSiteScheduleBySiteIdQuery } = siteSchedulesApi;
